/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const MoreVerticalStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 6.49995C11.5029 6.49995 11.1 6.09701 11.1 5.59995C11.1 5.10289 11.5029 4.69995 12 4.69995C12.4971 4.69995 12.9 5.10289 12.9 5.59995C12.9 6.09701 12.4971 6.49995 12 6.49995Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.8999C11.5029 12.8999 11.1 12.497 11.1 12C11.1 11.5029 11.5029 11.1 12 11.1C12.4971 11.1 12.9 11.5029 12.9 12C12.9 12.497 12.4971 12.9 12 12.8999Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1 18.3999C11.1 18.897 11.5029 19.2999 12 19.2999C12.4971 19.2999 12.9 18.897 12.9 18.3999C12.9 17.9029 12.4971 17.4999 12 17.4999C11.5029 17.4999 11.1 17.9029 11.1 18.3999Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { MoreVerticalStrokeIcon };
